import { IMenuLink } from '../types/menuLink';

export const RENT_LINK: IMenuLink = {
  name: 'rent',
  title: 'Аренда',
  trackingLabel: 'rent',
  path: ['listingLinks', 'rent'],
  section: 'rent',
};

export const SALE_LINK: IMenuLink = {
  name: 'sale',
  title: 'Продажа',
  trackingLabel: 'sale',
  path: ['listingLinks', 'sale'],
  section: 'sale',
};

export const DEAL_RENT_LINK: IMenuLink = {
  name: 'dealRent',
  title: 'Сдай/Сними',
  trackingLabel: 'dealRent',
  path: ['listingLinks', 'dealRent'],
  section: 'dealRent',
};

export const NEWBUILDINGS_LINK: IMenuLink = {
  name: 'newbuildings',
  title: 'Новостройки',
  trackingLabel: 'newobjects',
  path: ['listingLinks', 'newobjects'],
  section: 'new-buildings',
};

export const COMMERCIAL_LINK: IMenuLink = {
  name: 'commercial',
  title: 'Коммерческая',
  trackingLabel: 'commercial',
  path: ['listingLinks', 'commercial'],
  section: 'commercial',
};

export const CALCULATOR_LINK: IMenuLink = {
  name: 'calculator',
  title: 'Оценка',
  trackingLabel: 'estimation',
  path: ['otherLinks', 'calculator'],
  section: 'valuation',
};

export const CIANPRO_LINK: IMenuLink = {
  name: 'cianpro',
  title: 'Циан.Pro',
  trackingLabel: 'Cian_pro',
  link: 'https://promo.cian.ru/profi',
  section: 'cianpro',
};

export const MORTGAGE_LINK: IMenuLink = {
  name: 'mortgage',
  title: 'Ипотека',
  trackingLabel: 'mortgage',
  path: ['mortgageLinks', 'main'],
};

export const ADDITIONAL1024PX_LINK: IMenuLink = {
  name: 'additional1024px',
  title: 'Ещё',
};

export const ADDITIONAL1093PX_LINK: IMenuLink = {
  name: 'additional1093px',
  title: 'Ещё',
};
